import {
  gameIdsByLicensedTerritory,
  type HighFrequencyGameId,
} from '@lottocom/high-frequency-game-mapping'

export const useHighFrequencyGameId = () => {
  const licensedTerritory = useLicensedTerritory({ raw: true })

  const key = licensedTerritory as keyof typeof gameIdsByLicensedTerritory
  const gameIds = gameIdsByLicensedTerritory[key] ?? []

  return (gameIds[0] ?? null) as Maybe<HighFrequencyGameId>
}
